export interface AccountingRule {
  id: number;
  account: string;
  accountName: string;
  accountType: string;
  debitRules: string[];
  creditRules: string[];
  complementaryContractIds: number[];
  active: boolean;
  accountingPlan?: AccountingPlan;
  accountingRuleVariabilities?: AccountingRuleVariability[];
}

export class AccountingRuleVariability {
  id?: number;
  ruleId: number;
  account: string;
  accountName: string;
  ruleTransId: string;
  ruleOperator: string;
  ruleValue: string;
  orderNumber: number;
  dataIndex?: number;
}

export class RegContractIndexCriteria {
  "name": string;
  "type": string;
  "dataIndice": number;
  "empZone"?: EmpZoneData;
}

export class EmpZoneData {
  "name": string;
  "transId": string;
  "type": string;
}

export class AccountingRuleView implements AccountingRule {
  account: string;
  accountName: string;
  accountType: string;
  accountingPlan?: AccountingPlan;
  active: boolean;
  creditRules: any[];
  debitRules: any[];
  complementaryContractIds: number[];
  complementaryContractsList?: { id: number, name: string }[];
  editMode?: boolean;
  id: number;
  newRule?: boolean;
  index?: number;
  modified?: boolean;
  accountingRuleVariabilities?: AccountingRuleVariability[]
}

export class AccountingCalculationRequest {
  id: number;
  launchDate: string;
  updateDate: string;
  payPeriodId: number;
  accountingPlanId: number;
  status: string;
  ruleExecs: any[];
}

export class AccountingPlan {
  id: number;
  name: string;
  payArrayNames?: string[];
  newPlan?: boolean;
  editMode?: boolean;
}

export interface AccountingPlanResponse {
  payload: AccountingPlan[];
  total: number;
}

export interface AccountingRuleResponse {
  payload: AccountingRule[];
  total: number;
}

export class AccountingPlanPaySerieDTO {
  accountingPlan: AccountingPlan;
  paySeriesIds: number[];
}

export interface RegulationFlatten {
  regulationFlatten: RegulationFlattenData;
  regulationPayFlatten: any;
}

export interface RegulationFlattenData {
  creationDate: string;
  cliRegId: number;
  payArrays: PayArray[];

}

export interface PayArray {
  arrayName: string;
  columnContent: string;

}
